import {Image} from '@/_application/core/components/ui/image';
import {formatThousandNumber, getImageAssetUrl} from '@/_application/core/utils/common';
import rangeMap from '@/lib/range-map';
import {useTranslation} from 'next-i18next';
import {roundNumber} from '@/_application/core/utils/number';

const InactiveStarIcon = getImageAssetUrl('icons/product-review-star-inactive.svg');
const ActiveStarIcon = getImageAssetUrl('icons/product-review-star-active.svg');

export const ProductRatingBox = ({
    ratingData: {ratingsCount, ratingSummary},
    showAverageRating,
}: {
    ratingData: {
        ratingsCount?: number;
        ratingSummary?: number;
    };
    showAverageRating?: boolean;
}) => {
    const {t} = useTranslation('common');

    if (!ratingSummary) {
        return <p className="text-xs text-KPZ_TextSecondary">{t('text-no-review')}</p>;
    }

    const rating = (ratingSummary / 100) * 5;
    const roundRating = Math.round(rating);
    const inactiveRating = 5 - roundRating;

    const validRating = roundNumber(rating, 1);

    return (
        <div className="flex h-4 items-center">
            {showAverageRating && <span className="mr-1 text-xs font-bold text-KPZ_text_1st">{validRating}</span>}

            <div className="flex items-center">
                <div className="flex items-center">
                    {rangeMap(roundRating, i => (
                        <Image
                            src={ActiveStarIcon}
                            width={12}
                            height={12}
                            alt={'active-rating'}
                            key={i}
                            className={'h-3 w-3'}
                            suppressHydrationWarning
                        />
                    ))}
                    {rangeMap(inactiveRating, i => (
                        <Image
                            src={InactiveStarIcon}
                            width={12}
                            height={12}
                            alt={'inactive-rating'}
                            key={i}
                            className={'h-3 w-3'}
                            suppressHydrationWarning
                        />
                    ))}
                </div>
            </div>
            {ratingsCount && (
                <span className="ml-1 text-xs text-KPZ_TextSecondary" suppressHydrationWarning>
                    ({formatThousandNumber(ratingsCount)})
                </span>
            )}
        </div>
    );
};
